var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstonia1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "estonia 1",
    clipPath: "url(#clip0_1626_513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.27646e-06 8.50074C-0.00122224 9.50942 0.177905 10.5102 0.528932 11.4558L8.50001 11.825L16.4711 11.4558C17.1763 9.5482 17.1763 7.45129 16.4711 5.54367L8.50001 5.17578L0.528932 5.54566C0.177905 6.49129 -0.00122224 7.49206 6.27646e-06 8.50074Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.50001 0C4.84501 0 1.72989 2.3043 0.528931 5.54492H16.4711C15.2701 2.3043 12.1547 0 8.50001 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4707 11.4551H0.528564C1.72952 14.6947 4.84497 17 8.49964 17C12.1543 17 15.2701 14.6957 16.4707 11.4551Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstonia1);
export default __webpack_public_path__ + "static/media/estonia 1.d09b97b18d25c76b73f3ba61599828ff.svg";
export { ForwardRef as ReactComponent };